module.exports = __webpack_public_path__ + "media/images/features/3/feature-3-item-default-640baa891136e843e8bc057fe48a3ac6.png";